module.exports = __webpack_public_path__ + "img/arrow-up-small-big.4660b64d.svg";